import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentUpdateService {

  private componentUpdateSource = new Subject<void>();
  private fileToDownload = new BehaviorSubject<string>('');
  private progressDownload = new BehaviorSubject<string>('0%');

  componentUpdate$ = this.componentUpdateSource.asObservable();
  $fileToDownload = this.fileToDownload.asObservable();
  $progressDownload = this.progressDownload.asObservable();

  updateComponent() {
    this.componentUpdateSource.next();
  }

  setFileToDownload(file: string) {
    this.fileToDownload.next(file);
  }

  setProgressDownload(progress: string) {
    this.progressDownload.next(progress);
  }

}